import React,{useEffect} from 'react'
import './WelcomeComponent.css'
import parse from "html-react-parser";
import { getWelcome } from '../../../features/aboutus/aboutusSlice';
import { useDispatch, useSelector } from "react-redux";

const WelcomeComponent = () => {

    const welcomes = useSelector((state) => state.aboutus.addWelcome);
    const dispatch = useDispatch();
 
  
    useEffect(() => {
      dispatch(getWelcome());
    }, [dispatch]);
    return (
        <section className='WelcomeComponent'>
            <div className='container'>
                {welcomes && welcomes.length > 0 ? (
                    welcomes.map((item, index) => (
                        <p key={index} className='title_text'>
                            {item?.description ? parse(String(item.description)) : ""}
                        </p>
                    ))
                ) : (
                    <p>Loading...</p>
                )}
            </div>
        </section>
    );
}

export default WelcomeComponent
